"use client";
import { useRef } from "react";

import type { HeroProps } from "../Hero/interface";
import Slide from "./Slide/Slide";
import SnapCarousel from "../ui/SnapCarousel";
import type { SnapCarouselHandle } from "../ui/SnapCarousel";
import styles from "./Slider.module.scss";

type SliderComponentProps = {
  index?: number,
  data: {
    id: string;
    __component: string;
    hero: HeroProps['data'][];
  }
}

const Slider:React.FC<SliderComponentProps> = (props) => {
  const { data } = props;
  const carouselRef = useRef<SnapCarouselHandle>(null);
  const sectionIndex = props.index;

  const visibleHeroes = data.hero.filter((slide) => !slide.hidden);
  const showArrows = visibleHeroes.length > 1;

  return (
    <section className={ styles.sliderWrapper }>
      <SnapCarousel ref={carouselRef}>
        {visibleHeroes.map((hero, index) => (
          <Slide
            key={hero.id}
            data={hero}
            carouselRef={carouselRef}
            showArrows={showArrows}
            isFirstSlide={sectionIndex === 0 && index === 0}
            imageLoading={ sectionIndex === 0 && index === 0 ? 'eager' : 'lazy' }
          />
        ))}
      </SnapCarousel>
    </section>
  );
}

export default Slider;
